import { render, staticRenderFns } from "./WarningControl.vue?vue&type=template&id=15eb4dc6&scoped=true&"
import script from "./WarningControl.vue?vue&type=script&lang=js&"
export * from "./WarningControl.vue?vue&type=script&lang=js&"
import style0 from "./WarningControl.vue?vue&type=style&index=0&id=15eb4dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb4dc6",
  null
  
)

export default component.exports